// Amount display rules for the Ledger tab. Kept apart from the view so the
// table, the cards and the detail panel can never format a figure differently.

// Indian-style grouping on the integer part only; the fractional part is
// re-attached exactly as received. Formatting the whole number instead would
// round it (toLocaleString defaults to 3 fraction digits), so a rate like
// 91.166 must keep its own decimals rather than gain or lose any.
export const showAmount = (value) => {
  if (value === null || value === undefined || value === '') return '-';
  const str = String(value).trim();
  if (!Number.isFinite(parseFloat(str))) return str;
  const sign = str.startsWith('-') ? '-' : '';
  const [intPart, fracPart] = str.replace(/^[-+]/, '').split('.');
  const grouped = Number(intPart || '0').toLocaleString('en-IN');
  return sign + grouped + (fracPart === undefined ? '' : '.' + fracPart);
};

// Same hex the mobile cards already used, shared so both views match.
const INFLOW_COLOR = '#4CAF50';
const OUTFLOW_COLOR = '#F44336';

// A zero debit or credit means nothing moved in that column, so it reads as a
// dash and the populated side stands out. Balance keeps its real 0.
export const showMovement = (value) => ((parseFloat(value) || 0) === 0 ? '-' : showAmount(value));

// Credit raises the balance, debit lowers it; a cell is coloured by the
// direction it actually moves money, so a negative credit reads as an outflow.
export const movementColor = (contribution) =>
  contribution > 0 ? INFLOW_COLOR : contribution < 0 ? OUTFLOW_COLOR : 'inherit';

// Exactly one of credit/debit is ever populated, so the card shows that field
// verbatim rather than a computed total. Either field can itself be negative,
// so the direction comes from the value's own sign, not from which column it
// sits in. direction: 1 inflow, -1 outflow, 0 for a zero-value row.
export const entryAmount = (entry) => {
  const useCredit = (parseFloat(entry.credit) || 0) !== 0;
  const raw = String((useCredit ? entry.credit : entry.debit) ?? '').trim();
  const magnitude = raw.replace(/^[-+]/, '') || '0';
  if ((parseFloat(raw) || 0) === 0) return { magnitude, direction: 0 };
  const isNegative = raw.startsWith('-');
  return { magnitude, direction: (useCredit ? !isNegative : isNegative) ? 1 : -1 };
};

// Sign leads the currency symbol: -₹1,00,000 rather than ₹-1,00,000.
export const showSignedInr = (value) => {
  const str = showAmount(value);
  if (str === '-') return str;
  return str.startsWith('-') ? `-₹${str.slice(1)}` : `₹${str}`;
};
